import { useDeviceType } from '@cian/ui-kit';
import { ActionButton } from 'shared/components/ActionButton';
import * as styles from './styles.css';
import { ITEMS } from './constants';
import clsx from 'clsx';

export const MarketLeadershipSection: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['text-block']}>
        <div className={styles['title']}>Продайте и сдайте быстрее с Циан — лидером рынка</div>
        <div className={styles['description']}>среди сервисов по недвижимости в ключевых регионах России</div>
      </div>
      <div className={styles['list']}>
        {ITEMS.map(({ id, image, title, description }) => (
          <div key={id} className={styles['item']}>
            <img className={styles['item-image']} src={image} alt={title} />
            <div className={styles['item-title']}>{title}</div>
            <div className={styles['item-description']}>{description}</div>
          </div>
        ))}
      </div>
      <ActionButton>Разместить объявление</ActionButton>
    </div>
  );
};
